export const verticalAlignTopIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M1 3V1h18v2zm8 16V6.8L6.4 9.4 5 8l5-5 5 5-1.4 1.4L11 6.8V19z"/></svg>`,
  name: 'vertical-align-top',
};
